import "@tailwindplus/elements";
import { initHeroCanvas } from "./hero-canvas";
import { initScrollReveal } from "./scroll-reveal";
import { initSiteHeader } from "./site-header";

initSiteHeader();
initScrollReveal();
initHeroCanvas();
